import * as React from "react";
import { Route } from "react-router";
import { EventEmitter } from "fbemitter";

import { LabelStore } from "../flux/Label/LabelStore";
import { ListStore } from "../flux/Grid/ListStore";
import { FlagStore } from "../flux/Flag/FlagStore";
import { ErrorStore } from "../flux/Error/ErrorStore";
import { EditCreateDivisionStore } from "../components/Pages/Division/EditCreateDivisionStore";
import { Division, EntityType } from "../../models";

import { UpsertDivisionCommand, ShowCreateDivisionCommand, ShowEditDivisionCommand } from "../components/Pages/Division/commands/index";
import { InitUpsertDivisionCommand } from "../components/Pages/Division/commands/InitUpsertDivisionCommand";

import { Polyglot } from "../../polyglot";
import { SearchFn } from "../../rest/Search";
import { CommitFn } from "../../rest/Commit";
import { Command1 } from "../../Command";
import { DivisionRoute } from "../components/Pages/Division/DivisionRoute";
import { routeFor } from "../routes";
import { SearchProps } from "../components/Pages/SearchProps";
import { TabSearchConfigurator } from "./configureSearchBox";

// This class is a configuration for Division tab
// Constructor receives and/or creates dependencies and injects them
export class DivisionTab
{
    private readonly tableTitleStore = new LabelStore();
    private readonly listStore = new ListStore<Division>(division => division.id, EntityType.Division);
    private readonly commitInProgressStore = new FlagStore();
    private readonly upsertErrorStore = new ErrorStore();
    private readonly upsertStore = new EditCreateDivisionStore();
    private readonly divisionLoadInProgress = new FlagStore();

    readonly markup: JSX.Element;
    readonly searchConfig: TabSearchConfigurator;
            
    constructor(polyglot: Polyglot, runSearch: SearchFn, commitEntity: CommitFn, getCurrentDivisionId: () => number, divisionEmitter: EventEmitter, changeCurrentDivisionCmd: Command1<number>)
    {
        this.searchConfig = new TabSearchConfigurator(polyglot, EntityType.Division, getCurrentDivisionId, divisionEmitter, this.tableTitleStore.dispatchToken);
        const divisionUpsertCmd = new UpsertDivisionCommand(polyglot, commitEntity, changeCurrentDivisionCmd, getCurrentDivisionId, this.listStore.dispatchToken, this.commitInProgressStore.dispatchToken, this.upsertErrorStore.dispatchToken);
        const divisionInitUpsertCmd = new InitUpsertDivisionCommand(runSearch, this.upsertStore, getCurrentDivisionId, this.divisionLoadInProgress.dispatchToken, this.upsertErrorStore.dispatchToken);
        const showCreateDivisionCommand = new ShowCreateDivisionCommand(this.upsertErrorStore.dispatchToken);
        const showEditDivisionCmd = new ShowEditDivisionCommand(this.upsertErrorStore.dispatchToken);

        this.markup = (
            <Route path={routeFor(EntityType.Division)} render={() => (
                <DivisionRoute
                    polyglot={polyglot}
                    tableTitleStore={this.tableTitleStore}
                    listStore={this.listStore}

                    {...this.searchConfig.searchBoxProps}

                    editStore={this.upsertStore}
                    divisionsLoadInProgress={this.divisionLoadInProgress}
                    upsertInProgressStore={this.commitInProgressStore}
                    upsertErrorStore={this.upsertErrorStore}
                    upsertCommand={divisionUpsertCmd}

                    initUpsertCommand={divisionInitUpsertCmd}
                    showCreateDivisionCommand={showCreateDivisionCommand}
                    showEditDivisionCommand={showEditDivisionCmd}

                    switchCommand={changeCurrentDivisionCmd}
                />
            )} />
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/init/division.tsx